import { useTranslation } from 'react-i18next';

import {
  Explainer,
  ExplainerBody,
  ExplainerContent,
  ExplainerCopy,
  ExplainerTitle,
  ExplainerTrigger,
} from './Explainer';

export const WhcUpliftPotentialExplainer = () => {
  const { t } = useTranslation();

  return (
    <Explainer>
      <ExplainerTrigger data-testid='water-explainer'>
        {t('shared.ncaDetail.details.labels.howDoWeMeasureThis')}
      </ExplainerTrigger>
      <ExplainerContent>
        <ExplainerTitle>{t('shared.ncaDetail.details.water.explainers.howDoMeasureThis.headline')}</ExplainerTitle>
        <ExplainerBody>
          <ExplainerCopy
            title={t('shared.ncaDetail.details.water.explainers.howDoMeasureThis.waterHoldingTitle')}
            body={t('shared.ncaDetail.details.water.explainers.howDoMeasureThis.waterHoldingBody')}
          />
          {/* TODO: MVP-5260 - Bring Confidence Interval back to charts  */}
          {/* <ExplainerCopy
            title={t('shared.ncaDetail.details.explainers.howDoMeasureThis.confidenceInterval.title')}
            body={t('shared.ncaDetail.details.explainers.howDoMeasureThis.confidenceInterval.body')}
          /> */}
        </ExplainerBody>
      </ExplainerContent>
    </Explainer>
  );
};
